import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = mergeToNew(categoryDetailLinkListStyles.container, {
    css: css`
        background: ${getColor("secondary")};
        border-radius: 6px;
    `,
});

categoryDetailLinkListStyles.subCategoryNameLinkItem = mergeToNew(
    categoryDetailLinkListStyles.subCategoryNameLinkItem,
    {
        css: css`
            padding: 8px 12px;
            border-bottom: 1px solid ${getColor("common.border")};
            &:last-of-type {
                border-bottom: none;
            }
        `,
    },
);
